import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../Button';

function LoginDash({ showMessage, title }) {

    useEffect(() => {
            document.title = title;
    }, [title]);

    const navigate = useNavigate();

    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");

    const [honey, setHoney] = useState("");

    const loginDash = async () => {

        if(honey !== ''){
            showMessage("error", "Login error.");
            return;
        }
    
        if (!email || !password ) {
            showMessage("error", "Please fill in all the fields.");
            return;
        }
 
        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('password', password);
            formData.append('honeyField', honey);
    
            const response = await fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=dashboardLogin', {
                method: 'POST',
                credentials: "include",
                body: formData,
            });
    
            const data = await response.json();
    
            if (data.success) {
                showMessage("success", "Login successful!");
                navigate("/dashboard")
            } else {
                showMessage("error", data.error);
            }
        } catch (err) {
            showMessage("error", "Something went wrong.");
        }
    };



    return (
      <>
        <div className='dash_section'>
            <div className="dash_wrapper">

                <div className='dashboard_login_wrapper'>
                    <p className='dashboard_login_title'>Login</p>

                    <input type="email" className='dashboard_login_input' placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>

                    <input type="password" className='dashboard_login_input' placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}/>

                    <input type="text" className='dashboard_login_honey' value={honey} onChange={(e) => setHoney(e.target.value)}/>

                    <Button type="button" text="Login" class="dashboard_login_button" onClick={loginDash}/>
                </div>
                
            </div>
        </div>
      </>
    );
}

export default LoginDash;